import { useHead as useUnhead } from "@unhead/react";
import { useContent } from "../hooks/useContent";
import { buildOrganizationSchema, buildWebSiteSchema } from "../utils/structured-data";

/**
 * Injects the site-wide Organization and WebSite JSON-LD on every route.
 *
 * Rendered inside AppLayout (within HeadProvider + LanguageProvider) so it runs
 * for all pages. During SSG the script tags are captured per route and written
 * into the static HTML — the entity anchor that page-level schemas reference.
 */
export const GlobalStructuredData = () => {
    const { language } = useContent();
    const lang = language === "en" ? "en" : "de";

    useUnhead({
        script: [
            {
                type: "application/ld+json",
                key: "ld-organization",
                innerHTML: JSON.stringify(buildOrganizationSchema(lang)),
            },
            {
                type: "application/ld+json",
                key: "ld-website",
                innerHTML: JSON.stringify(buildWebSiteSchema(lang)),
            },
        ],
    });

    return null;
};
